(function () {
  const DEBOUNCE_MS = 500;
  const MIN_CHARS = 2;

  const form = document.querySelector('.ially-search__form');
  const input = form && form.querySelector('[data-predictive-search-input]');
  const resultsEl = form && form.querySelector('[data-predictive-search-results]');

  if (!form || !input || !resultsEl) return;

  let debounceTimer = null;
  let currentController = null;

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatPrice(value) {
    const num = Number(value);
    if (!value || Number.isNaN(num)) return '';

    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency,
      }).format(num);
    } catch (e) {
      return `${num.toFixed(2)} ${currency}`;
    }
  }

  function showResults(html) {
    resultsEl.innerHTML = html;
    resultsEl.hidden = false;
  }

  function hideResults() {
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';
  }

  function renderLoading() {
    showResults('<div class="ially-search__preview-loading">Buscando…</div>');
  }

  function renderEmpty(query) {
    showResults(`<div class="ially-search__preview-empty">Nenhum resultado para "${escapeHtml(query)}"</div>`);
  }

  function renderProducts(products) {
    const items = products
      .map((product) => {
        const image = product.image
          ? `<img src="${product.image}" alt="" width="48" height="48" loading="lazy">`
          : '';
        const price = formatPrice(product.price_min);

        return `
          <li class="ially-search__preview-item" role="option">
            <a href="${product.url}">
              <span class="ially-search__preview-thumb">${image}</span>
              <span class="ially-search__preview-info">
                <span class="ially-search__preview-title">${escapeHtml(product.title)}</span>
                ${price ? `<span class="ially-search__preview-price">${price}</span>` : ''}
              </span>
            </a>
          </li>
        `;
      })
      .join('');

    showResults(`<ul class="ially-search__preview-list">${items}</ul>`);
  }

  function fetchPredictions(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    renderLoading();

    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;

    fetch(url, { signal: currentController.signal })
      .then((res) => res.json())
      .then((data) => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          renderEmpty(query);
        } else {
          renderProducts(products);
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') hideResults();
      });
  }

  input.addEventListener('input', () => {
    const query = input.value.trim();

    clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      if (currentController) currentController.abort();
      hideResults();
      return;
    }

    debounceTimer = setTimeout(() => fetchPredictions(query), DEBOUNCE_MS);
  });

  document.addEventListener('click', (event) => {
    if (!form.contains(event.target)) hideResults();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hideResults();
  });
})();
